// removed by extract-text-webpack-plugin
module.exports = {"gallery":"src-components-Gallery----gallery-module---gallery---3eI93","text":"src-components-Gallery----gallery-module---text---3GMWi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Gallery/gallery.module.css
// module id = 205
// module chunks = 40275710597918 191283472321578